// @ts-nocheck
import React from 'react'
import { colors } from '@lmc/common/constants'

import { EditableTitle } from '../EditableTitle'

const renderButton = (buttonLabel, onPress) => <div>{buttonLabel}</div>

const SectionHeader = ({
  buttonLabel,
  children,
  compact,
  editableTitle,
  greyLine,
  isSubSection,
  lineStyles,
  onPress,
  subtitle,
  subtitleTwo,
  title,
  titleStyles,
  onSaveTitle,
}) => {
  const styles = {
    container: {
      width: '100%',
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    titleContainer: {
      minHeight: !isSubSection && 34,
      width: editableTitle && '100%', // this might be an issue if you want buttons with an editable title
    },
    childContainer: {},
    line: {
      height: 2,
      marginBottom: 8,
      background: greyLine ? colors.grey : null,
      marginTop: subtitle ? 2 : isSubSection ? 3 : 0,
      width: '100%',
      ...lineStyles,
    },
    subtitle: {
      opacity: 0.6,
      marginTop: 0,
    },
    topContainer: {
      alignItems: 'flex-end',
      display: 'flex',
      justifyContent: 'space-between',
    },
    title: {
      fontSize: isSubSection ? 20 : compact ? 24 : null,
      marginBottom: 6,
      ...titleStyles,
    },
  }

  return (
    <div style={styles.container}>
      <div style={styles.flexContainer}>
        <div style={styles.titleContainer}>
          {editableTitle ? (
            <EditableTitle
              titleStyles={styles.title}
              title={title}
              onSaveTitle={onSaveTitle}
            />
          ) : (
            <h2 style={styles.title}>
              {title}
              {buttonLabel && renderButton(buttonLabel, onPress)}
            </h2>
          )}
          {subtitle ? (
            <p
              style={{
                ...styles.subtitle,
                marginBottom: subtitleTwo ? 0 : 5,
              }}
            >
              {subtitle}
            </p>
          ) : null}
          {subtitleTwo ? (
            <p
              style={{
                ...styles.subtitle,
                marginBottom: 5,
              }}
            >
              {subtitleTwo}
            </p>
          ) : null}
        </div>
        <div>{children || null}</div>
      </div>
    </div>
  )
}

export default SectionHeader
